import Christine from "../../images/christine.png";
import Experience from "../../images/Experience.svg";

export const homeObjOne = {
  id: "presentation",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Christine Lucas",
  headline: "Une avocate à votre écoute",
  description:
    "La confiance se mérite. Si je ne prends pas en compte votre situation personnelle, si je ne cherche pas à vous comprendre, si je ne suis pas sensible à vos contraintes et besoins, et que je ne vous accompagne pas, je n’agis pas au mieux de vos intérêts.",
  description2: "Je suis votre unique interlocutrice, c’est un choix pour être au mieux à votre écoute, disponible et réactive.",
  buttonLabel: "Mon expérience",
  imgStart: false,
  img: Christine,
  alt: "Studying",
  dark: true,
  primary: true,
  darkText: false,
  tolink: "pres2",
};

export const homeObjTwo = {
  id: "pres2",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Des années d'expérience",
  headline: "Mon expérience",
  description: "Titulaire d’un DESS en Conseil d’Entreprises, j’obtiens mon CAPA en 2000 et prête serment en février 2001.",
  description2:
    "Je débute dans les cabinets d’affaires, la vie des entreprises devient mon quotidien avec son volet juridique, social et contractuel. Par la suite, le volet judiciaire m’est confié, j’exploite cette opportunité et finis par gérer les procédures commerciales, civiles et sociales. Certains clients me demandent alors de les assister dans leurs difficultés personnelles et familiales. Cette approche technique pluridisciplinaire me décide à créer mon propre cabinet.",
  buttonLabel: "Mes compétences",
  imgStart: true,
  img: Experience,
  alt: "Studying",
  dark: false,
  primary: false,
  darkText: true,
  tolink: "competences",
};
